import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "@/components/ui/dialog";
import { MapPin, Settings } from "lucide-react";

interface LocationPermissionModalProps {
  open: boolean;
  onSkip: () => void;
  onReload: () => void;
}

export const LocationPermissionModal = ({
  open,
  onSkip,
  onReload
}: LocationPermissionModalProps) => {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onSkip()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center">
          <div className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-gray-50">
            <MapPin className="h-16 w-16" style={{ color: "#62e8c2" }} />
          </div>
          <DialogTitle className="text-center text-lg">
            位置情報の利用が拒否されています
          </DialogTitle>
          <DialogDescription className="text-center text-sm text-gray-600">
            スポットの推薦には位置情報が必要です。
            <br />
            ブラウザの設定で位置情報を有効にしてください。
          </DialogDescription>
        </DialogHeader>

        <div className="rounded-lg bg-blue-50 p-4">
          <div className="flex items-start gap-3">
            <Settings className="h-5 w-5 text-blue-700" />
            <div className="text-xs">
              <p className="mb-1 flex h-5 items-center text-blue-700">設定方法：</p>
              <ol className="list-inside list-decimal space-y-1 text-blue-700">
                <li>LINEのアプリ設定で位置情報を許可</li>
                <li>デフォルトブラウザのアプリ設定で位置情報を許可</li>
                <li>ページを再読み込み</li>
              </ol>
            </div>
          </div>
        </div>

        <DialogFooter className="flex-col space-y-2 sm:flex-col sm:space-x-0">
          <Button onClick={onSkip}>設定スキップ：名古屋駅（代表地点）を基準に開く</Button>
          <Button variant="outline" onClick={onReload}>
            ページの再読み込み
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
